module.exports = __webpack_public_path__ + "img/five-1.586fce3f.png";